
























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class ModalAuthPrompt extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly hint!: string;
  @Prop() readonly title!: string;
  @Prop() readonly msg!: string;
  @Prop() readonly loading!: boolean;

  password = "";
  showPassword = false;
  rules = {
    required: value => !!value || "Required."
  };

  @Watch("value")
  changedValue(val) {
    if (!val) {
      this.password = "";
    }
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  get submitParams() {
    return {
      password: this.password
    };
  }

  submit() {
    this.$emit("submit", this.submitParams);
  }

  close() {
    this.show = false;
  }
}
